module.exports = __webpack_public_path__ + "static/img/uy.8328c7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/uy.png
// module id = PP9M
// module chunks = 18